import PropTypes from 'prop-types'

// Internal components
import LazyImage from '../LazyImage/LazyImage'

const PageCover = (props) => {
  const { figures, modifiers } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const addPageCoverFigure = (figure, modifier) => {
    return (
      <div className={`PageCover-figure PageCover-figure--${modifier}`} key={`PageCover-figure--${modifier}`}>
        <div className="PageCover-figureWrap">
          {figure && (
            <LazyImage
              image={figure.image}
              alt={figure.alt}
              sizes={'(min-width: 1440px) 800px, (min-width: 460px) 50vw, 100vw'}
              modifiers={['LazyImage--pageCover']}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={`PageCover${modifierClasses}`}>
      <div className="PageCover-inner">
        {addPageCoverFigure(figures[0].CoverFigureRight[0], 'primary')}
        {addPageCoverFigure(figures[0].CoverFigureLeft[0], 'secondary')}
      </div>
    </div>
  )
}

PageCover.propTypes = {
  figures: PropTypes.array.isRequired,
  modifiers: PropTypes.array
}

export default PageCover
